import { slideDown, slideUp } from "../../helpers/dom-manipulation/animation";
import { createHtmlElement } from "../../helpers/dom-manipulation/dom-manipulation";

/**
 * Read an element's rendered height the way jQuery's `outerHeight()` did.
 *
 * @param {Element | null} element - The element to measure.
 * @returns {number} The height in pixels, or 0 if the element is missing.
 */
function readHeight(element) {
    return element ? parseFloat(getComputedStyle(element).height) || 0 : 0;
}

const searchfilterhelpers = {
    /** @type {NodeListOf<HTMLElement> | null} */
    $filtername: null,

    /**
     * Filter elements matching `filtername` by a search string.
     *
     * @param {string} filtername - CSS selector for the filter items.
     * @param {string} search - The search string to filter by.
     * @returns {void}
     */
    filter(filtername, search) {
        this.$filtername = document.querySelectorAll(filtername);
        this.disableScrollBinders();
        this.$filtername.forEach((item) => {
            let name = /** @type {string} */ (item.dataset.name).toLowerCase();
            search = search.trim().toLowerCase();
            item.style.display = name.includes(search) ? "block" : "none";
        });
        this.enableScrollBinders();
    },

    /**
     * Unbind scroll-shrink listeners during filtering.
     *
     * @returns {void}
     */
    disableScrollBinders() {
        window.menuShrinker.shrinkListenerBinder("off");
    },

    /**
     * Re-bind scroll-shrink listeners after filtering.
     *
     * @returns {void}
     */
    enableScrollBinders() {
        window.menuShrinker.shrinkListenerBinder("on");
    },
};
window.searchfilterhelpers = searchfilterhelpers;

const searchfiltermobile = {
    /**
     * Reset the search view.
     *
     * @returns {void}
     */
    reset() {
        searchViewEs6.reset();
        document.querySelectorAll(".category-content").forEach((item) => {
            if (item instanceof HTMLElement) item.style.display = "none";
        });
    },

    /**
     * Bind click/input handlers for mobile filter UI.
     *
     * @returns {void}
     */
    init() {
        document.querySelectorAll(".category-header").forEach((header) => {
            header.addEventListener("click", (event) => {
                const target = event.target;
                if (!(target instanceof Element)) return;
                const category = target.closest(".category");
                category
                    ?.querySelector(":scope > .category-header")
                    ?.classList.toggle("active");
                const content = category?.querySelector(
                    ":scope > .category-content",
                );
                if (content instanceof HTMLElement) {
                    content.style.display =
                        content.style.display === "none" ? "" : "none";
                }
            });
        });
        document
            .getElementById("brand-search-mobile")
            ?.addEventListener("input", (e) => {
                let search = /** @type {HTMLInputElement} */ (e.target).value;
                searchfilterhelpers.filter(".brandfilter", search);
            });
        document
            .getElementById("type-search-mobile")
            ?.addEventListener("input", (e) => {
                let search = /** @type {HTMLInputElement} */ (e.target).value;
                searchfilterhelpers.filter(".typefilter", search);
            });
        document
            .querySelectorAll(".taggroup-search-mobile")
            .forEach((input) => {
                input.addEventListener("input", (e) => {
                    let search = /** @type {HTMLInputElement} */ (e.target)
                        .value;
                    let id = /** @type {HTMLElement} */ (e.target).dataset.id;
                    searchfilterhelpers.filter(
                        `.tagfilter[data-taggroupid="${id}"]`,
                        search,
                    );
                });
            });
    },
};
window.searchfiltermobile = searchfiltermobile;

const searchfilter = {
    /**
     * Reset the search view.
     *
     * @returns {void}
     */
    reset() {
        searchViewEs6.reset();
    },

    /**
     * Bind input handlers for desktop filter UI.
     *
     * @returns {void}
     */
    init() {
        document
            .getElementById("brand-search")
            ?.addEventListener("input", (e) => {
                let search = /** @type {HTMLInputElement} */ (e.target).value;
                searchfilterhelpers.filter(".brandfilter", search);
            });
        document
            .getElementById("type-search")
            ?.addEventListener("input", (e) => {
                let search = /** @type {HTMLInputElement} */ (e.target).value;
                searchfilterhelpers.filter(".typefilter", search);
            });
        document.querySelectorAll(".taggroup-search").forEach((input) => {
            input.addEventListener("input", (e) => {
                let search = /** @type {HTMLInputElement} */ (e.target).value;
                let id = /** @type {HTMLElement} */ (e.target).dataset.id;
                searchfilterhelpers.filter(
                    `.tagfilter[data-taggroupid="${id}"]`,
                    search,
                );
            });
        });
    },
};
window.searchfilter = searchfilter;

let searchViewEs6 = {
    /** @type {string} */
    api_url: "/json/search?",
    /** @type {boolean} */
    brands_enabled: true,
    /** @type {boolean} */
    types_enabled: true,
    /** @type {boolean} */
    extras_enabled: true,
    /** @type {boolean} */
    genders_enabled: true,
    /** @type {any[]} */
    selected_outlet: [],
    /** @type {any[]} */
    selected_sections: [],
    /** @type {any[]} */
    selected_categories: [],
    /** @type {any[]} */
    selected_subcategories: [],
    /** @type {any[]} */
    selected_brands: [],
    /** @type {any[]} */
    selected_series: [],
    /** @type {any[]} */
    selected_ids: [],
    /** @type {string} */
    selected_term: "",
    /** @type {any[]} */
    selected_types: [],
    /** @type {any[]} */
    selected_tags: [],
    /** @type {any[]} */
    selected_extras: [],
    /** @type {any[]} */
    selected_genders: [],
    /** @type {number} */
    selected_sort: 1,

    /** @type {any[]} */
    products: [],
    /** @type {any[]} */
    brands: [],
    /** @type {any[]} */
    types: [],
    /** @type {any[]} */
    extras: [],
    /** @type {any[]} */
    tags: [],
    /** @type {any[]} */
    genders: [],

    /** @type {any[]} */
    available_brands: [],
    /** @type {any[]} */
    available_types: [],
    /** @type {any[]} */
    available_extras: [],
    /** @type {any[]} */
    available_tags: [],
    /** @type {any[]} */
    available_genders: [],

    /** @type {boolean} */
    dermaOnly: false,
    /** @type {boolean} */
    premiumOnly: false,
    /** @type {number | null} */
    minMemberPrice: null,
    /** @type {number | null} */
    maxMemberPrice: null,

    /** @type {number} */
    total: 0,
    /** @type {number} */
    pageSize: 0,
    /** @type {number} */
    pageCount: 0,
    /** @type {number} */
    page: 0,
    /** @type {number} */
    sort: 0,
    /** @type {string} */
    term: "",

    /** @type {boolean} */
    isLoading: false,

    /**
     * Returns whether the view is currently loading.
     *
     * @returns {boolean} True if a query is in progress.
     */
    loading() {
        return this.isLoading;
    },

    /**
     * Set the loading state and toggle the loading UI.
     *
     * @param {boolean} loading - Whether the view is loading.
     * @returns {void}
     */
    setLoading(loading) {
        this.isLoading = loading;
        const loader = document.querySelector("#search-view .logo-loader");
        const grid = document.querySelector("#grid");
        if (loading) {
            if (loader instanceof HTMLElement) loader.style.display = "";
            grid?.classList.add("loading");
        } else {
            if (loader instanceof HTMLElement) loader.style.display = "none";
            grid?.classList.remove("loading");
        }
    },

    /**
     * Build a full URL for a given page number.
     *
     * @param {number} pageNumber - The page number to encode.
     * @returns {string} The URL with query string.
     */
    buildPageUrl(pageNumber) {
        /** @type {{ name: string, value: any }[]} */
        let params = [];

        params.push({ name: "page", value: pageNumber });

        let queryString = this.buildQueryString(params);
        return `${location.pathname}?${queryString}`;
    },

    /**
     * Serialize an array of name/value pairs into a query string.
     *
     * @param {{ name: string, value: any }[]} params - The parameters to serialize.
     * @returns {string} The query string without leading '?'.
     */
    buildQueryString(params) {
        let url = "";
        params.forEach(({ value, name }) => {
            if (value !== "") {
                url = url.concat(`&${name}=${value}`);
            }
        });
        return url.substr(1);
    },

    /**
     * Build the full search API query URL from current state.
     *
     * @returns {string} The full API URL with query parameters.
     */
    buildQuery() {
        /** @type {{ name: string, value: any }[]} */
        let params = [];

        params.push({ name: "html", value: "true" });
        params.push({ name: "sections", value: this.selected_sections.join() });
        params.push({
            name: "categories",
            value: this.selected_categories.join(),
        });
        params.push({
            name: "subcategories",
            value: this.selected_subcategories.join(),
        });
        params.push({ name: "series", value: this.selected_series.join() });
        params.push({ name: "brands", value: this.selected_brands.join() });
        params.push({ name: "types", value: this.selected_types.join() });
        params.push({ name: "tags", value: this.selected_tags.join() });
        params.push({ name: "extras", value: this.selected_extras.join() });
        params.push({ name: "genders", value: this.selected_genders.join() });
        params.push({ name: "premiumOnly", value: this.premiumOnly });
        params.push({ name: "dermaOnly", value: this.dermaOnly });

        if (this.minMemberPrice != null) {
            params.push({ name: "minMemberPrice", value: this.minMemberPrice });
        }

        if (this.maxMemberPrice != null) {
            params.push({ name: "maxMemberPrice", value: this.maxMemberPrice });
        }

        if (this.term != null) {
            params.push({ name: "term", value: this.term });
        }

        if (this.selected_outlet) {
            params.push({ name: "outlet", value: this.selected_outlet });
        }

        params.push({ name: "page", value: this.page });
        params.push({ name: "sort", value: this.sort });

        let url = this.buildQueryString(params);
        return this.api_url.concat(url);
    },

    /**
     * Update the browser history state to reflect current filters.
     *
     * @returns {void}
     */
    updateHistory() {
        /** @type {{ name: string, value: any }[]} */
        let params = [];

        if (this.brands_enabled) {
            params.push({ name: "brands", value: this.selected_brands.join() });
        }

        if (this.types_enabled) {
            params.push({ name: "types", value: this.selected_types.join() });
        }

        params.push({ name: "tags", value: this.selected_tags.join() });

        if (this.extras_enabled) {
            params.push({ name: "extras", value: this.selected_extras.join() });
        }

        if (this.genders_enabled) {
            params.push({
                name: "genders",
                value: this.selected_genders.join(),
            });
        }

        if (this.sort > 0) params.push({ name: "sort", value: this.sort });

        params.push({ name: "page", value: this.page });

        let queryString = this.buildQueryString(params);

        if (queryString !== "") queryString = `?${queryString}`;

        history.replaceState(
            window.history.state,
            "",
            `${location.pathname}${queryString}`,
        );
    },

    /**
     * Execute a search query via a POST request.
     *
     * @param {((response: any) => void) | undefined} [success] - Success callback.
     * @param {((error: any) => void) | undefined} [error] - Error callback.
     * @returns {void}
     */
    query(success, error) {
        this.setLoading(true);
        const url = this.buildQuery();

        fetch(url, {
            method: "POST",
            headers: {
                "Content-Type":
                    "application/x-www-form-urlencoded; charset=UTF-8",
            },
            body: new URLSearchParams({
                ids: JSON.stringify(this.selected_ids),
                _token: CSRF_TOKEN,
            }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(
                        `Request failed with status ${response.status}`,
                    );
                }

                return response.json();
            })
            .then((response) => {
                this.setLoading(false);
                if (success !== undefined) success(response);
                this.updateHistory();
            })
            .catch((e) => {
                this.setLoading(false);
                if (error !== undefined) error(e);
            });
    },

    /**
     * Whether there is a next page of results.
     *
     * @returns {boolean} True if more pages exist.
     */
    hasNextPage() {
        return this.page < this.pageCount;
    },

    /**
     * Whether there is a previous page of results.
     *
     * @returns {boolean} True if a previous page exists.
     */
    hasPreviousPage() {
        return this.page > 1;
    },

    /**
     * Check if a value exists in an array of objects on a given field.
     *
     * @param {any[]} arr - The array to search.
     * @param {string} field - The property name to compare.
     * @param {any} value - The value to look for.
     * @returns {boolean} True if a matching element was found.
     */
    array_value_exists(arr, field, value) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i][field] === value) {
                return true;
            }
        }
        return false;
    },

    /**
     * Find the first element in an array of objects matching a field value.
     *
     * @param {any[]} arr - The array to search.
     * @param {string} field - The property name to compare.
     * @param {any} value - The value to look for.
     * @returns {any} The matching element, or null if not found.
     */
    array_find(arr, field, value) {
        for (let item of arr) {
            if (item[field] === value) {
                return item;
            }
        }

        return null;
    },

    /**
     * Look up a tag by ID within nested tag groups.
     *
     * @param {any[]} arr - The array of tag groups to search.
     * @param {any} id - The tag ID to find.
     * @returns {any} The matching tag, or null if not found.
     */
    lookupTag(arr, id) {
        for (let i = 0; i < arr.length; i++) {
            for (let tag of arr[i].tags) {
                if (tag["id"] === id) {
                    return tag;
                }
            }
        }
        return null;
    },

    /**
     * Check if a brand is in the available brands list.
     *
     * @param {any} id - The brand ID.
     * @returns {boolean} True if the brand is available.
     */
    isBrandAvailable(id) {
        return this.array_value_exists(this.available_brands, "brandId", id);
    },

    /**
     * Check if a product type is in the available types list.
     *
     * @param {any} id - The product type ID.
     * @returns {boolean} True if the type is available.
     */
    isTypeAvailable(id) {
        return this.array_value_exists(
            this.available_types,
            "productTypeId",
            id,
        );
    },

    /**
     * Check if an extra filter is in the available extras list.
     *
     * @param {any} id - The extra filter ID.
     * @returns {boolean} True if the extra is available.
     */
    isExtraAvailable(id) {
        return this.array_value_exists(this.available_extras, "id", id);
    },

    /**
     * Check if a tag is in the available tags list.
     *
     * @param {any} id - The tag ID.
     * @returns {boolean} True if the tag is available.
     */
    isTagAvailable(id) {
        return this.lookupTag(this.available_tags, id) != null;
    },

    /**
     * Check if a gender filter is in the available genders list.
     *
     * @param {any} id - The gender ID.
     * @returns {boolean} True if the gender is available.
     */
    isGenderAvailable(id) {
        return this.available_genders.includes(id);
    },

    /**
     * Get a brand object by ID from the full brands list.
     *
     * @param {any} id - The brand ID.
     * @returns {any} The brand object, or null.
     */
    getBrand(id) {
        return this.array_find(this.brands, "brandId", id);
    },

    /**
     * Get a product type object by ID from the full types list.
     *
     * @param {any} id - The product type ID.
     * @returns {any} The type object, or null.
     */
    getType(id) {
        return this.array_find(this.types, "productTypeId", id);
    },

    /**
     * Get a tag object by ID from the full tags list.
     *
     * @param {any} id - The tag ID.
     * @returns {any} The tag object, or null.
     */
    getTag(id) {
        return this.lookupTag(this.tags, id);
    },

    /**
     * Get an extra filter object by ID from the full extras list.
     *
     * @param {any} id - The extra ID.
     * @returns {any} The extra object, or null.
     */
    getExtra(id) {
        return this.array_find(this.extras, "id", id);
    },

    /**
     * Get a gender value by ID from the full genders list.
     *
     * @param {any} id - The gender ID.
     * @returns {any} The gender value.
     */
    getGender(id) {
        return this.genders[this.genders.indexOf(id)];
    },

    /**
     * Check if a brand is currently selected.
     *
     * @param {any} id - The brand ID.
     * @returns {boolean} True if the brand is selected.
     */
    isBrandSelected(id) {
        return this.selected_brands.includes(id);
    },

    /**
     * Check if a tag is currently selected.
     *
     * @param {any} id - The tag ID.
     * @returns {boolean} True if the tag is selected.
     */
    isTagSelected(id) {
        return this.selected_tags.includes(id);
    },

    /**
     * Check if a product type is currently selected.
     *
     * @param {any} id - The product type ID.
     * @returns {boolean} True if the type is selected.
     */
    isTypeSelected(id) {
        return this.selected_types.includes(id);
    },

    /**
     * Check if an extra filter is currently selected.
     *
     * @param {any} id - The extra filter ID.
     * @returns {boolean} True if the extra is selected.
     */
    isExtraSelected(id) {
        return this.selected_extras.includes(id);
    },

    /**
     * Check if a gender filter is currently selected.
     *
     * @param {any} id - The gender ID.
     * @returns {boolean} True if the gender is selected.
     */
    isGenderSelected(id) {
        return this.selected_genders.includes(id);
    },

    /**
     * Replace the product grid HTML and reinitialise lazy-loading and tooltips.
     *
     * @param {string} products - The HTML string of product cards.
     * @returns {void}
     */
    updateProducts(products) {
        const grid = document.querySelector("#grid");
        if (grid) grid.innerHTML = products;
        window.luxTooltips.init();
    },

    /**
     * Clear the product grid HTML.
     *
     * @param {string} [products] - Unused parameter (kept for compatibility).
     * @returns {void}
     */
    clearProducts(products) {
        const grid = document.querySelector("#grid");
        if (grid) grid.innerHTML = "";
    },

    /**
     * Scroll to top and fetch the current page of results.
     *
     * @returns {void}
     */
    getPage() {
        this.scrollToTop();

        this.query(
            (/** @type {any} */ { products }) => {
                this.updateProducts(products);
                this.updatePagers();
            },
            (/** @type {any} */ error) => {},
        );
    },

    /**
     * Navigate to the previous page of results.
     *
     * @returns {void}
     */
    previousPage() {
        if (this.loading()) return;

        if (!this.hasPreviousPage()) return;

        this.page--;

        this.getPage();
    },

    /**
     * Navigate to the next page of results.
     *
     * @returns {void}
     */
    nextPage() {
        if (this.loading()) return;

        if (!this.hasNextPage()) return;
        this.page++;

        this.getPage();
    },

    /**
     * Re-sort filter items within their containers based on selected/available/disabled state.
     *
     * @returns {void}
     */
    updateFilters() {
        document.querySelectorAll(".filters").forEach((container) => {
            const selected = /** @type {HTMLElement[]} */ (
                Array.from(
                    container.querySelectorAll(":scope > .item-selected"),
                )
            );
            const available = /** @type {HTMLElement[]} */ (
                Array.from(
                    container.querySelectorAll(":scope > .item-available"),
                )
            );
            const disabled = /** @type {HTMLElement[]} */ (
                Array.from(
                    container.querySelectorAll(":scope > .item-disabled"),
                )
            );

            /**
             * Order two filter items by their `data-sort` value.
             *
             * @param {HTMLElement} a - The first item.
             * @param {HTMLElement} b - The second item.
             * @returns {number} `1` if `a` should sort after `b`, otherwise `-1`.
             */
            const bySort = (a, b) =>
                Number(b.dataset.sort) < Number(a.dataset.sort) ? 1 : -1;

            container.append(...selected.sort(bySort));
            container.append(...available.sort(bySort));
            container.append(...disabled.sort(bySort));

            const category = container.closest(".category");
            const filterinfo = category?.querySelector(".filter-info");
            if (filterinfo instanceof HTMLElement) {
                let info = filterinfo.dataset.format;
                if (info !== undefined) {
                    const total = available.length + disabled.length;
                    info = info.replace(
                        "{available}",
                        String(available.length),
                    );
                    info = info.replace("{total}", String(total));
                    filterinfo.innerHTML = info;
                }
            }
        });
    },

    /**
     * Reset a filter item to its default (no state) CSS classes.
     *
     * @param {Element} item - The filter item.
     * @returns {void}
     */
    setItemDefault(item) {
        item.classList.remove(
            "item-disabled",
            "item-available",
            "item-selected",
        );
    },

    /**
     * Mark a filter item as disabled.
     *
     * @param {Element} item - The filter item.
     * @returns {void}
     */
    setItemDisabled(item) {
        this.setItemDefault(item);
        item.classList.add("item-disabled");
    },

    /**
     * Mark a filter item as available.
     *
     * @param {Element} item - The filter item.
     * @returns {void}
     */
    setItemAvailable(item) {
        this.setItemDefault(item);
        item.classList.add("item-available");
    },

    /**
     * Mark a filter item as selected.
     *
     * @param {Element} item - The filter item.
     * @returns {void}
     */
    setItemSelected(item) {
        this.setItemDefault(item);
        item.classList.add("item-selected");
        item.closest(".filter-group-wrapper")?.classList.add(
            "filter-group-active",
        );
    },

    /**
     * Update the visual state of all type filter items.
     *
     * @returns {void}
     */
    updateTypes() {
        if (!this.types_enabled) return;
        document.querySelectorAll(".typefilter").forEach((item) => {
            const id = Number(/** @type {HTMLElement} */ (item).dataset.id);
            if (this.isTypeSelected(id)) {
                return this.setItemSelected(item);
            }
            if (this.isTypeAvailable(id)) {
                return this.setItemAvailable(item);
            }
            this.setItemDisabled(item);
        });
    },

    /**
     * Update the visual state of all brand filter items.
     *
     * @todo Unlike `updateTypes`/`updateTags`/`updateExtras`, this never consults
     * `available_brands`, so a brand with no matching products stays clickable
     * instead of being disabled. Covered by a test, so the behaviour is pinned
     * either way — decide deliberately before changing it.
     *
     * @returns {void}
     */
    updateBrands() {
        if (!this.brands_enabled) return;
        document.querySelectorAll(".brandfilter").forEach((item) => {
            const id = Number(/** @type {HTMLElement} */ (item).dataset.id);
            if (this.isBrandSelected(id)) {
                this.setItemSelected(item);
            } else {
                this.setItemAvailable(item);
            }
        });
    },

    /**
     * Update the visual state of all tag filter items.
     *
     * @returns {void}
     */
    updateTags() {
        document.querySelectorAll(".tagfilter").forEach((item) => {
            const id = Number(/** @type {HTMLElement} */ (item).dataset.id);
            if (this.isTagSelected(id)) {
                return this.setItemSelected(item);
            }
            if (this.isTagAvailable(id)) {
                return this.setItemAvailable(item);
            }
            this.setItemDisabled(item);
        });
    },

    /**
     * Update the visual state of all extra filter items.
     *
     * @returns {void}
     */
    updateExtras() {
        if (!this.extras_enabled) return;
        document.querySelectorAll(".extrafilter").forEach((item) => {
            const id = Number(/** @type {HTMLElement} */ (item).dataset.id);
            if (this.isExtraSelected(id)) {
                return this.setItemSelected(item);
            }
            if (this.isExtraAvailable(id)) {
                return this.setItemAvailable(item);
            }
            this.setItemDisabled(item);
        });
    },

    /**
     * Update the visual state of all gender filter items.
     *
     * @returns {void}
     */
    updateGenders() {
        if (!this.genders_enabled) return;
        document.querySelectorAll(".genderfilter").forEach((item) => {
            const id = /** @type {HTMLElement} */ (item).dataset.id;
            if (this.isGenderSelected(id)) {
                return this.setItemSelected(item);
            }
            if (this.isGenderAvailable(id)) {
                return this.setItemAvailable(item);
            }
            this.setItemDisabled(item);
        });
    },

    /**
     * Update product count info labels.
     *
     * @returns {void}
     */
    updateInfo() {
        document.querySelectorAll(".product-count").forEach((item) => {
            let info = /** @type {HTMLElement} */ (item).dataset.format ?? "";
            info = info.replace("{total}", String(this.total));
            /** @type {HTMLElement} */ (item).innerHTML = info;
        });
    },

    /**
     * Hide all pager elements.
     *
     * @returns {void}
     */
    hidePagers() {
        document.querySelectorAll(".pager").forEach((item) => {
            if (item instanceof HTMLElement) item.style.display = "none";
        });
    },

    /**
     * Update pager elements — page info text, previous/next visibility and hrefs.
     *
     * @returns {void}
     */
    updatePagers() {
        document.querySelectorAll(".page-info").forEach((item) => {
            if (!(item instanceof HTMLElement)) return;
            let info = item.dataset.format ?? "";
            info = info.replace("{page}", String(this.page));
            info = info.replace("{pageCount}", String(this.pageCount));
            item.innerHTML = info;
        });
        document.querySelectorAll(".pager").forEach((item) => {
            if (!(item instanceof HTMLElement)) return;
            if (this.hasPreviousPage() || this.hasNextPage()) {
                item.style.display = "flex";
            } else {
                item.style.display = "none";
            }
        });
        document
            .querySelectorAll(".previous-page, .previous-page-elastic")
            .forEach((item) => {
                if (!(item instanceof HTMLElement)) return;
                if (this.hasPreviousPage()) {
                    item.style.display = "flex";
                    item.setAttribute("href", this.buildPageUrl(this.page - 1));
                } else {
                    item.style.display = "none";
                    item.removeAttribute("href");
                }
            });
        document
            .querySelectorAll(".next-page, .next-page-elastic")
            .forEach((item) => {
                if (!(item instanceof HTMLElement)) return;
                if (this.hasNextPage()) {
                    item.style.display = "flex";
                    item.setAttribute("href", this.buildPageUrl(this.page + 1));
                } else {
                    item.style.display = "none";
                    item.removeAttribute("href");
                }
            });
    },

    /**
     * Create a filter badge element with a click handler.
     *
     * @todo The badge is an HTML string carrying an inline `onclick`, so it calls
     * back through the *global* `searchview`. Scoping this module to a normal
     * import would break every badge silently; a test pins the exact onclick
     * string so that shows up as a failure rather than in production.
     *
     * @param {string} name - The display name for the badge.
     * @param {string} func - The onclick JS expression string.
     * @returns {HTMLElement} The badge element.
     */
    createBadge(name, func) {
        return /** @type {HTMLElement} */ (
            createHtmlElement(
                `<span class="lux-filter-btn" onclick="${func}">${name}<span class="filter-delete svg-filter-luxplus"></span></span>`,
            )
        );
    },

    /**
     * Rebuild the selected filters badge list and update the count.
     *
     * @todo Only the brand branch guards its lookup (`if (brand)`). A type/tag/extra
     * id that no longer resolves — e.g. from a bookmarked URL pointing at a
     * since-deleted filter — throws on the unguarded `.productTypeName` /
     * `.translation.name` / `.name` dereference. The brand guard also still
     * increments `total`, so the count can exceed the badges actually shown.
     *
     * @returns {void}
     */
    updateSelectedFilters() {
        const selectedfilters = document.querySelectorAll(".selected-filters");
        const selectedfilterscount = document.querySelector(
            ".selected-filters-count",
        );
        const isStockPage = document.querySelector(".page-stock") !== null;
        let total = 0;

        selectedfilters.forEach((item) => {
            total = 0;
            const container = item.querySelector(".selected-filters-container");

            if (container) container.innerHTML = "";
            if (this.brands_enabled) {
                this.selected_brands.forEach((/** @type {any} */ id) => {
                    let brand = this.getBrand(id);
                    if (brand) {
                        let badge = this.createBadge(
                            brand.brandName,
                            `searchview.toggleBrand(${id})`,
                        );
                        container?.append(badge);
                    }
                    total++;
                });
            }

            if (this.types_enabled) {
                this.selected_types.forEach((/** @type {any} */ id) => {
                    let type = this.getType(id);
                    let badge = this.createBadge(
                        type.productTypeName,
                        `searchview.toggleType(${id})`,
                    );
                    container?.append(badge);
                    total++;
                });
            }

            this.selected_tags.forEach((/** @type {any} */ id) => {
                let type = this.getTag(id);
                let badge = this.createBadge(
                    type.translation.name,
                    `searchview.toggleTag(${id})`,
                );
                container?.append(badge);
                total++;
            });

            if (this.extras_enabled) {
                this.selected_extras.forEach((/** @type {any} */ id) => {
                    let extra = this.getExtra(id);
                    let badge = this.createBadge(
                        extra.name,
                        `searchview.toggleExtra(${id})`,
                    );

                    if (isStockPage) {
                        badge.classList.add("d-none");
                    }

                    container?.append(badge);
                    total++;
                });
            }

            if (this.genders_enabled) {
                this.selected_genders.forEach((/** @type {any} */ id) => {
                    let gender = this.getGender(id);
                    let genderName = document
                        .querySelector(`a.genderfilter[data-id="${id}"]`)
                        ?.getAttribute("data-name");
                    let badge = this.createBadge(
                        genderName ?? "",
                        `searchview.toggleGender('${gender}')`,
                    );
                    container?.append(badge);
                    total++;
                });
            }

            if (
                (isStockPage && this.extras_enabled && total > 1) ||
                (!isStockPage && total > 0)
            ) {
                if (item instanceof HTMLElement) item.style.display = "";
            } else {
                if (item instanceof HTMLElement) item.style.display = "none";
            }
        });

        let info =
            selectedfilterscount instanceof HTMLElement
                ? selectedfilterscount.dataset.format
                : undefined;
        if (info !== undefined && selectedfilterscount instanceof HTMLElement) {
            info = info.replace("{count}", String(total));
            selectedfilterscount.innerHTML = info;
        }

        if (selectedfilterscount instanceof HTMLElement) {
            selectedfilterscount.style.display = total > 0 ? "" : "none";
        }
    },

    /**
     * Refresh all UI components — filters, info, pagers, and selected badges.
     *
     * @returns {void}
     */
    updateUI() {
        this.updateBrands();
        this.updateExtras();
        this.updateTypes();
        this.updateTags();
        this.updateGenders();
        this.updateSelectedFilters();
        this.updateFilters();
        this.updateInfo();
        this.updatePagers();
    },

    /**
     * Handle a filter change — reset page, fetch results, and update UI.
     *
     * @returns {void}
     */
    changed() {
        this.hidePagers();
        this.clearProducts();
        this.updateSelectedFilters();

        document.querySelectorAll(".categories-wrapper").forEach((el) => {
            el.classList.remove("active");
        });
        document
            .querySelectorAll(".category-wrapper.expanded .submenu-wrapper")
            .forEach((el) => {
                if (el instanceof HTMLElement) slideUp(el);
            });
        document.querySelectorAll(".category-wrapper").forEach((el) => {
            el.classList.remove("active", "expanded", "active-menu-parent");
        });

        this.page = 1;
        this.pageCount = 1;

        this.query(
            (/** @type {any} */ response) => {
                this.total = response.total;
                this.pageCount = response.pageCount;

                this.available_brands = response.availableBrands;
                this.available_extras = response.availableExtras;
                this.available_tags = response.availableTags;
                this.available_types = response.availableTypes;
                this.available_genders = response.availableGenders;

                this.updateProducts(response.products);
                this.updateUI();
            },
            (/** @type {any} */ error) => {},
        );
    },

    /**
     * Scroll the page to the top of the search view.
     *
     * @returns {void}
     */
    scrollToTop() {
        const headerHeight = readHeight(document.querySelector("header"));
        const view = document.querySelector("#search-view");

        if (view) {
            const top =
                view.getBoundingClientRect().top +
                window.pageYOffset -
                headerHeight -
                24;
            window.scrollTo({ top, behavior: "smooth" });
        }
    },

    /**
     * Set the sort order and refresh results.
     *
     * @param {any} id - The sort option value.
     * @returns {void}
     */
    setSort(id) {
        if (this.loading()) return;

        this.sort = id;
        this.changed();
    },

    /**
     * Toggle a value in an array (add if missing, remove if present) and refresh.
     *
     * @param {any[]} arr - The array to toggle the value in.
     * @param {any} id - The value to toggle.
     * @returns {void}
     */
    toggle(arr, id) {
        if (this.loading()) return;

        let index = arr.indexOf(id);
        if (index !== -1) {
            arr.splice(index, 1);
        } else {
            arr.push(id);
        }
        this.changed();
    },

    /**
     * Toggle a brand filter by ID.
     *
     * @param {any} id - The brand ID.
     * @returns {void}
     */
    toggleBrand(id) {
        this.toggle(this.selected_brands, id);
    },

    /**
     * Toggle a type filter by ID (only if available or already selected).
     *
     * @param {any} id - The type ID.
     * @returns {void}
     */
    toggleType(id) {
        if (this.isTypeAvailable(id) || this.isTypeSelected(id)) {
            this.toggle(this.selected_types, id);
        }
    },

    /**
     * Toggle a tag filter by ID (only if available or already selected).
     *
     * @param {any} id - The tag ID.
     * @returns {void}
     */
    toggleTag(id) {
        if (this.isTagAvailable(id) || this.isTagSelected(id)) {
            this.toggle(this.selected_tags, id);
        }
    },

    /**
     * Toggle an extra filter by ID (only if available or already selected).
     *
     * @param {any} id - The extra ID.
     * @returns {void}
     */
    toggleExtra(id) {
        if (this.isExtraAvailable(id) || this.isExtraSelected(id)) {
            this.toggle(this.selected_extras, id);
        }
    },

    /**
     * Toggle a gender filter by ID (only if available or already selected).
     *
     * @param {any} id - The gender ID.
     * @returns {void}
     */
    toggleGender(id) {
        if (this.isGenderAvailable(id) || this.isGenderSelected(id)) {
            this.toggle(this.selected_genders, id);
        }
    },

    /**
     * Reset all selected filters and refresh results.
     *
     * @returns {void}
     */
    reset() {
        if (this.types_enabled) this.selected_types = [];
        if (this.brands_enabled) {
            this.selected_brands = [];
        }

        this.selected_tags = [];

        if (
            this.extras_enabled &&
            document.querySelector(".page-stock") === null
        ) {
            this.selected_extras = [];
        }

        if (this.genders_enabled) this.selected_genders = [];
        this.sort = 0;
        this.changed();
    },

    /**
     * Initialise the search view — bind all event handlers and set up the filter UI.
     *
     * @returns {void}
     */
    init() {
        this.sort = this.selected_sort;
        this.term = this.selected_term;

        document.querySelectorAll(".extrafilter").forEach((item) => {
            item.addEventListener("click", (event) => {
                const target = /** @type {HTMLElement} */ (event.target);
                searchViewEs6.toggleExtra(Number(target.dataset.id));
            });
        });
        document.querySelectorAll(".brandfilter").forEach((item) => {
            item.addEventListener(
                "click",
                /** @type {EventListener} */ (
                    /**
                     * Toggle the brand this element represents.
                     *
                     * @this {HTMLElement}
                     * @param {MouseEvent} e - The click event.
                     * @returns {void}
                     */
                    function (e) {
                        e.preventDefault();
                        const id = Number(this.dataset.id);
                        searchViewEs6.toggleBrand(id);
                    }
                ),
            );
        });
        document.querySelectorAll(".typefilter").forEach((item) => {
            item.addEventListener("click", (event) => {
                const target = /** @type {HTMLElement} */ (event.target);
                searchViewEs6.toggleType(Number(target.dataset.id));
            });
        });
        document.querySelectorAll(".submenu-list .tag").forEach((item) => {
            item.addEventListener(
                "click",
                /** @type {EventListener} */ (
                    /**
                     * Scroll to the landing page products and select this tag.
                     *
                     * @this {HTMLElement}
                     * @returns {void}
                     */
                    function () {
                        const landingPage = document.getElementById(
                            "landing-page-products",
                        );
                        if (landingPage) {
                            const top =
                                landingPage.getBoundingClientRect().top +
                                window.pageYOffset;
                            window.scrollTo({ top, behavior: "smooth" });
                        }

                        searchViewEs6.toggleTag(Number(this.dataset.id));
                    }
                ),
            );
        });
        document.querySelectorAll(".tagfilter").forEach((item) => {
            item.addEventListener("click", (event) => {
                const target = /** @type {HTMLElement} */ (event.target);
                searchViewEs6.toggleTag(Number(target.dataset.id));
            });
        });
        document.querySelectorAll(".genderfilter").forEach((item) => {
            item.addEventListener("click", (event) => {
                const target = /** @type {HTMLElement} */ (event.target);
                searchViewEs6.toggleGender(target.dataset.id);
            });
        });
        document.querySelectorAll(".next-page").forEach((item) => {
            item.addEventListener("click", (event) => {
                event.preventDefault();
                searchViewEs6.nextPage();
            });
        });
        document.querySelectorAll(".previous-page").forEach((item) => {
            item.addEventListener("click", (event) => {
                event.preventDefault();
                searchViewEs6.previousPage();
            });
        });
        document
            .getElementById("products-sorting")
            ?.addEventListener("change", (event) => {
                const target = /** @type {HTMLSelectElement} */ (event.target);
                searchViewEs6.setSort(target.value);
            });
        document.querySelectorAll(".reset-filter").forEach((item) => {
            item.addEventListener("click", () => {
                searchViewEs6.reset();
            });
        });
        this.updateUI();

        /* -------------------- Search filters -------------------- */
        setTimeout(() => {
            searchViewFiltersHeight();
            searchViewHideExtraFilters();
            searchViewShowExtraToggle();
            searchViewWrapFilters();
        }, 0);

        const searchViewFilterGroups = document.querySelectorAll(
            "#search-filter-desktop .filters-container > div.filter-group-wrapper",
        ).length;

        /** @type {Array<(event: MouseEvent) => void>} */
        let outsideClickListeners = [];

        /**
         * Toggle a filter group open/closed and bind outside-click dismissal.
         *
         * @this {HTMLElement}
         * @param {MouseEvent} e - The click event.
         * @returns {void}
         */
        const searchViewToggleFilter = function (e) {
            e.stopPropagation();
            const wrapper = this.closest(".filter-group-wrapper");

            document
                .querySelectorAll(
                    "#search-filter-desktop .filter-group-wrapper",
                )
                .forEach((group) => {
                    if (group === wrapper) return;
                    group.classList.remove("active");
                    const content = group.querySelector(
                        ":scope > .filters-content",
                    );
                    if (content instanceof HTMLElement) slideUp(content);
                });

            wrapper?.classList.toggle("active");

            const content = wrapper?.querySelector(":scope > .filters-content");

            if (wrapper?.classList.contains("active")) {
                if (content instanceof HTMLElement) slideDown(content);

                /**
                 * Close the group once a click lands outside it.
                 *
                 * @param {MouseEvent} event - The click event.
                 * @returns {void}
                 */
                const outsideClickListener = (event) => {
                    const target = event.target;
                    if (
                        target instanceof Element &&
                        target.closest(
                            "#search-filter-desktop .filter-group-wrapper .filters-content, .toggle-extra-filters",
                        )
                    ) {
                        return;
                    }
                    closeFilters();
                };

                outsideClickListeners.push(outsideClickListener);
                window.addEventListener("click", outsideClickListener);
            } else if (content instanceof HTMLElement) {
                slideUp(content);
            }
        };

        const closeFilters = () => {
            document
                .querySelectorAll(
                    "#search-filter-desktop .filter-group-wrapper .filters-content",
                )
                .forEach((content) => {
                    if (content instanceof HTMLElement) slideUp(content);
                });
            document
                .querySelectorAll(
                    "#search-filter-desktop .filter-group-wrapper",
                )
                .forEach((group) => group.classList.remove("active"));
            outsideClickListeners.forEach((listener) =>
                window.removeEventListener("click", listener),
            );
            outsideClickListeners = [];
        };

        /**
         * Toggle the extra filters container open/closed.
         *
         * @this {HTMLElement}
         * @returns {void}
         */
        const searchViewToggleExtraFilters = function () {
            const wrapper = this.closest(".toggle-extra-filters-wrapper");
            wrapper?.classList.toggle("active");

            document
                .querySelectorAll(
                    "#search-filter-desktop .extra-filters-container .filter-group-wrapper",
                )
                .forEach((group) => {
                    group.classList.remove("active");
                    const content = group.querySelector(
                        ":scope > .filters-content",
                    );
                    if (content instanceof HTMLElement) slideUp(content);
                });

            const container = document.querySelector(
                "#search-filter-desktop .extra-filters-container",
            );

            if (wrapper?.classList.contains("active")) {
                this.setAttribute("aria-label", "Close filters");
                if (container instanceof HTMLElement) slideDown(container);
            } else {
                this.setAttribute("aria-label", "Expand filters");
                if (container instanceof HTMLElement) slideUp(container);
            }
        };

        const searchViewShowExtraToggle = () => {
            const windowWidth = document.documentElement.clientWidth;
            const wrapper = document.querySelector(
                "#search-filter-desktop .toggle-extra-filters-wrapper",
            );

            if (
                (windowWidth >= 1724 && searchViewFilterGroups > 7) ||
                (windowWidth >= 1250 &&
                    windowWidth < 1724 &&
                    searchViewFilterGroups > 6) ||
                (windowWidth < 1250 && searchViewFilterGroups > 4)
            ) {
                wrapper?.classList.remove("hide");
                wrapper?.classList.add("show");
            } else {
                wrapper?.classList.remove("show");
                wrapper?.classList.add("hide");
            }
        };

        const searchViewFiltersHeight = () => {
            document
                .querySelectorAll(
                    "#search-filter-desktop .filter-group-wrapper .filters-content",
                )
                .forEach((el) => {
                    if (!(el instanceof HTMLElement)) return;
                    const filtersHeight = readHeight(el);

                    el.style.height = `${filtersHeight}px`;
                    el.style.visibility = "initial";
                    el.style.display = "none";
                });
        };

        const searchViewHideExtraFilters = () => {
            const container = document.querySelector(
                "#search-filter-desktop .extra-filters-container",
            );
            if (container instanceof HTMLElement) {
                container.style.height = "auto";
                container.style.overflow = "initial";
                container.style.display = "none";
            }
        };

        const searchViewWrapFilters = () => {
            const windowWidth = document.documentElement.clientWidth;
            const filtersContainer = document.querySelector(
                "#search-filter-desktop .filters-container",
            );
            if (!filtersContainer) return;

            const expanded =
                document.querySelector(
                    ".filter-categories-container.expanded",
                ) !== null;

            /**
             * Wrap the filter groups from `startIndex` onward into a new
             * `.extra-filters-container`, inserted right after `.filters-container`.
             *
             * @param {number} startIndex - Zero-based index of the first group to wrap.
             * @returns {void}
             */
            const wrapFrom = (startIndex) => {
                const groups = Array.from(
                    filtersContainer.querySelectorAll(
                        ":scope > .filter-group-wrapper",
                    ),
                ).slice(startIndex);

                if (groups.length === 0) return;

                const wrapper = document.createElement("div");
                wrapper.className = "extra-filters-container";
                filtersContainer.after(wrapper);
                wrapper.append(...groups);
            };

            if (windowWidth >= 1724 && searchViewFilterGroups > 6) {
                wrapFrom(expanded ? 6 : 7);
            } else if (windowWidth >= 1250 && searchViewFilterGroups > 5) {
                wrapFrom(expanded ? 5 : 6);
            } else if (windowWidth < 1250 && searchViewFilterGroups > 4) {
                wrapFrom(expanded ? 3 : 4);
            }
        };

        const searchViewFiltersResize = () => {
            const container = document.querySelector(
                "#search-filter-desktop .extra-filters-container",
            );
            const filtersContainer = document.querySelector(
                "#search-filter-desktop .filters-container",
            );

            if (container && filtersContainer) {
                filtersContainer.append(...Array.from(container.children));
                container.remove();
            }

            document
                .querySelectorAll(
                    "#search-filter-desktop .filter-group-wrapper",
                )
                .forEach((group) => group.classList.remove("active"));
            document
                .querySelectorAll(
                    "#search-filter-desktop .filter-group-wrapper .filters-content",
                )
                .forEach((content) => {
                    if (content instanceof HTMLElement) slideUp(content);
                });

            searchViewWrapFilters();

            const toggleWrapper = document.querySelector(
                "#search-filter-desktop .toggle-extra-filters-wrapper",
            );
            const newContainer = document.querySelector(
                "#search-filter-desktop .extra-filters-container",
            );

            if (toggleWrapper?.classList.contains("active")) {
                if (newContainer instanceof HTMLElement) {
                    newContainer.style.height = "auto";
                    newContainer.style.overflow = "initial";
                }
            } else {
                searchViewHideExtraFilters();
            }
        };

        /**
         * Create a simple debounced function wrapper.
         *
         * @param {(...args: any[]) => void} func - The function to debounce.
         * @returns {(event: any) => void} The debounced function.
         */
        function debounce(func) {
            /** @type {ReturnType<typeof setTimeout> | undefined} */
            let timer;
            return (/** @type {any} */ event) => {
                if (timer) clearTimeout(timer);
                timer = setTimeout(func, 100, event);
            };
        }

        document
            .querySelectorAll("#search-filter-desktop .filter-group-wrapper h4")
            .forEach((h4) => {
                h4.addEventListener(
                    "click",
                    /** @type {EventListener} */ (searchViewToggleFilter),
                );
            });
        document.querySelectorAll(".toggle-extra-filters").forEach((toggle) => {
            toggle.addEventListener(
                "click",
                /** @type {EventListener} */ (searchViewToggleExtraFilters),
            );
        });
        document
            .querySelectorAll(".filter-categories-container .categories-title")
            .forEach((title) => {
                title.addEventListener("click", searchViewFiltersResize);
            });
        searchViewWrapFilters();

        let headerHeight = readHeight(document.querySelector("header"));
        let topBarHeight = 0;
        const productGridWrapper = document.querySelector(
            ".product-grid-wrapper",
        );

        const topBar = document.querySelector(".top-bar");
        if (topBar) {
            topBarHeight = readHeight(topBar);
        }

        /** @type {number} */
        let productGridHeight = 0;
        /** @type {number} */
        let stickyFiltersTop = 0;

        if (productGridWrapper) {
            const pgRect = productGridWrapper.getBoundingClientRect();
            const productGridTop = pgRect.top + window.pageYOffset;
            productGridHeight = readHeight(productGridWrapper);
            stickyFiltersTop = productGridTop - headerHeight - topBarHeight;
        }

        const filterCategories = document.querySelector(".filter-categories");
        if (filterCategories instanceof HTMLElement) {
            filterCategories.style.setProperty(
                "--header-height",
                `${headerHeight}px`,
            );
        }

        const mobileFilterButton = document.querySelector(
            ".sticky-filters .btn-mobile-filter",
        );
        /** @type {boolean | null} */
        let mobileFilterShown = null;
        /** @type {number | null} */
        let scrollFrame = null;

        /**
         * Re-sync the sticky filter bar with the current scroll position.
         *
         * Runs at most once per frame and only writes to the DOM when a value
         * actually changed — an unthrottled handler here costs a style
         * recalculation on every scroll event.
         *
         * @returns {void}
         */
        const onScroll = () => {
            scrollFrame = null;

            const nextHeaderHeight = readHeight(
                document.querySelector("header"),
            );

            if (nextHeaderHeight !== headerHeight) {
                headerHeight = nextHeaderHeight;
                if (filterCategories instanceof HTMLElement) {
                    filterCategories.style.setProperty(
                        "--header-height",
                        `${headerHeight}px`,
                    );
                }
            }

            if (!productGridWrapper) {
                return;
            }

            const scrollTop = window.pageYOffset;
            const shouldShow =
                scrollTop > stickyFiltersTop &&
                scrollTop < productGridHeight + stickyFiltersTop;

            if (shouldShow !== mobileFilterShown) {
                mobileFilterShown = shouldShow;
                mobileFilterButton?.classList.toggle("show", shouldShow);
            }
        };

        window.addEventListener("scroll", () => {
            if (scrollFrame === null) {
                scrollFrame = window.requestAnimationFrame(onScroll);
            }
        });

        window.addEventListener(
            "resize",
            debounce((/** @type {any} */ e) => {
                searchViewFiltersResize();
                searchViewShowExtraToggle();
            }),
        );
    },
};

window.searchview = searchViewEs6;

/**
 * Bind the mobile/desktop search filter UI and initialise the search view once ready.
 *
 * @returns {void}
 */
function initSearchView() {
    setTimeout(() => {
        searchfiltermobile.init();
        searchfilter.init();
        searchViewEs6.init();
    }, 0);
}

window.initSearchView = initSearchView;
